module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-compare"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.ebitda"
    }
  }), _vm._v("\n                    Kontoplan\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "journal-toggle-wrap"
  }, [_c('label', {
    staticClass: "journal-toggle"
  }, [_c('span', {
    staticClass: "journal-toggle__switch",
    class: {
      'is-on': _vm.includeJournal
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeJournal),
      expression: "includeJournal"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeJournal) ? _vm._i(_vm.includeJournal, null) > -1 : (_vm.includeJournal)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeJournal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeJournal = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeJournal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeJournal = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "journal-toggle__slider"
  })]), _vm._v(" "), _c('span', {
    staticClass: "journal-toggle__label"
  }, [_vm._v("Medtag kassekladder")])])]), _vm._v(" "), (_vm.accountingYearsCheck && 'last_year_closed' in _vm.accountingYearsCheck && _vm.accountingYearsCheck.last_year_closed === false && !_vm.$auth.user().name.includes('Demo')) ? _c('div', {
    staticClass: "warning"
  }, [_c('b', [_vm._v("OBS! Seneste regnskabsår (" + _vm._s(_vm.accountingYearsCheck.year) + ") er ikke lukket i e-conomic.")]), _vm._v("\n                        Dette betyder, at tallene i din kontoplan summeres for både seneste regnskabsår samt det nuværende. Log in på e-conomic og luk det seneste regnskabsår for at se de korrekte tal. OBS! Du kan lukke og åbne et regnskabsår lige så ofte, det er nødvendigt.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.sortedAccounts) ? _c('div', {
    staticClass: "ebitda-wrapper"
  }, [_c('div', {
    staticClass: "line top"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("Bogført")]), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("Kassekladde")]) : _vm._e(), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("Total")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.sortedAccounts), function(accountCategory) {
    return _c('div', {
      key: accountCategory.uuid + '_' + accountCategory.name,
      staticClass: "line",
      class: {
        'bold': accountCategory.account_type === 'custom', 'selected': _vm.selectedAccountCategory && _vm.selectedAccountCategory.uuid === accountCategory.uuid, 'no-hover': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      on: {
        "click": function($event) {
          return _vm.selectAccountCategory(accountCategory)
        }
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                                " + _vm._s(accountCategory.name) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(accountCategory.entries_total)) + "\n                            ")]), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(accountCategory.journal_total)) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(accountCategory.total)) + "\n                            ")]) : _vm._e()])
  })], 2) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedAccountCategory) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    " + _vm._s(_vm.selectedAccountCategory.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(_vm.includeJournal && _vm.categoryHasJournalAccounts) ? _c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#666",
      "text-align": "center",
      "margin-top": "-15px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                        Konti med posteringer fra kassekladden er markeret med farvet baggrund.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.selectedAccountCategory.accounts.length > 0) ? _c('div', {
    staticClass: "ebitda-wrapper child"
  }, [_c('div', {
    staticClass: "line top"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("Bogført")]), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("Kassekladde")]) : _vm._e(), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("Total")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.selectedAccountCategory.accounts), function(account) {
    return ((_vm.includeJournal ? account.total : account.entries_total) !== 0) ? _c('div', {
      key: account.account_number,
      staticClass: "line",
      class: {
        'selected': _vm.selectedAccount && _vm.selectedAccount.uuid === account.uuid, 'is-journal': _vm.includeJournal && Number(account.journal_total) !== 0
      },
      on: {
        "click": function($event) {
          return _vm.selectAccount(account)
        }
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                                " + _vm._s(account.account_number) + "\n                                -\n                                " + _vm._s(account.name) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(account.entries_total)) + "\n                            ")]), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(account.journal_total)) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(account.total)) + "\n                            ")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                                " + _vm._s(_vm.selectedAccountCategory.name) + " i alt\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(_vm.selectedAccountCategory.entries_total)) + "\n                            ")]), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(_vm.selectedAccountCategory.journal_total)) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(_vm.selectedAccountCategory.total)) + "\n                            ")]) : _vm._e()])], 2) : _c('div', [_vm._v("\n                        Denne konto har ingen underkonti\n                    ")])])]) : _c('div', [_vm._v("\n                Vælg en konto for at se dens underkonti her\n            ")]), _vm._v(" "), (_vm.selectedAccount) ? _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Posteringer: " + _vm._s(_vm.selectedAccount.account_number) + " - " + _vm._s(_vm.selectedAccount.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(_vm.includeJournal && _vm.entriesHaveJournal) ? _c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#666",
      "text-align": "center",
      "margin-top": "-15px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                        Posteringer fra kassekladden er markeret med farvet baggrund.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.filteredAccountEntries) ? _c('div', {
    staticClass: "entries-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.filteredAccountEntries), function(entry) {
    return _c('div', {
      key: entry._source + '_' + entry.uuid,
      staticClass: "entry-line",
      class: {
        'is-journal': entry._source === 'journal'
      }
    }, [_c('div', {
      staticClass: "entry-date"
    }, [_vm._v(_vm._s(entry.date.split('-').reverse().join('/')))]), _vm._v(" "), _c('div', {
      staticClass: "entry-number"
    }, [(entry.voucher_number) ? _c('a', {
      attrs: {
        "href": 'https://secure.e-conomic.com/vouchers/' + entry.voucher_number,
        "target": "_blank"
      }
    }, [_vm._v("\n                                    " + _vm._s(entry.voucher_number) + "\n                                ")]) : _c('span', [_vm._v(_vm._s(entry.entry_number))])]), _vm._v(" "), _c('div', {
      staticClass: "entry-text"
    }, [_vm._v(_vm._s(entry.text))]), _vm._v(" "), _c('div', {
      staticClass: "entry-attachment"
    }, [(entry.hasAttachment) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openAttachment(entry)
        }
      }
    }, [(entry.loadingAttachment) ? _c('span', [_vm._v("Henter...")]) : _c('span', [_vm._v("Vis")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "entry-amount"
    }, [_vm._v(_vm._s(_vm._f("currency")(entry.amount)))])])
  }), _vm._v(" "), (_vm.filteredAccountEntries.length === 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "13px"
    }
  }, [_vm._v("\n                            Ingen posteringer i denne periode\n                        ")]) : _vm._e()], 2) : _c('box-loading', {
    attrs: {
      "height": "100"
    }
  })], 1)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "entry-line top"
  }, [_c('div', {
    staticClass: "entry-date"
  }, [_vm._v("Dato")]), _vm._v(" "), _c('div', {
    staticClass: "entry-number"
  }, [_vm._v("Bilagsnr.")]), _vm._v(" "), _c('div', {
    staticClass: "entry-text"
  }, [_vm._v("Tekst")]), _vm._v(" "), _c('div', {
    staticClass: "entry-attachment"
  }, [_vm._v("Bilag")]), _vm._v(" "), _c('div', {
    staticClass: "entry-amount"
  }, [_vm._v("Beløb")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0466fc80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning/ebitda.vue
// module id = 790
// module chunks = 0